import * as React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Body, Header3, Caption } from "./Typography"
import { Link } from "gatsby"
import { FiArrowRight } from "react-icons/fi"

const BlogCardContainer = styled(Link)`
  display: grid;
  grid-template-columns: 286px 1fr;
  gap: 32px;
  align-content: start;
  align-items: start;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
  }
`

const BlogCardImage = styled(GatsbyImage)``

const BlogCardTextContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 8px;
  justify-items: start;
`

const BlogCardTag = styled(Caption)`
  padding: 5px 10px;
  background: var(--primary015);
  color: var(--base100);
`

const BlogCard = ({ post }) => {
  return (
    <BlogCardContainer to={post.path.alias}>
      <BlogCardImage
        image={
          post.relationships.field_blog_image.localFile.childImageSharp
            .gatsbyImageData
        }
      />
      <BlogCardTextContainer>
        <BlogCardTag>{post.relationships.field_category[0].name}</BlogCardTag>
        <Header3>
          {post.title}
          <FiArrowRight style={{ marginLeft: 8, strokeWidth: 1.75 }} />
        </Header3>
        <Body style={{ color: "var(--base070)" }}>
          {post.field_description}
        </Body>
      </BlogCardTextContainer>
    </BlogCardContainer>
  )
}

export default BlogCard
